class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');
    this.triggeringElement = null; // Store the element that opened the cart

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open(triggeringElement = null) {
    // Store the triggering element for focus return
    this.triggeringElement = triggeringElement;

    this.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    // Focus on the first focusable element (close button) instead of the drawer itself
    const [closeButton1, closeButton2] = this.drawer.querySelectorAll('[data-cart-button-close]');

    const closeButton =
      this.dataset.isCartEmpty == 'true' ? closeButton1 : closeButton2 || closeButton1;

    setTimeout(() => {
      if (closeButton) {
        trapFocus(this.drawer, closeButton);
        // closeButton.focus();
      } else {
        this.drawer.focus();
        trapFocus(this.drawer);
      }
      this.hideBackgroundContent();
    }, 100);

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    // Remove aria-hidden from main content
    this.showBackgroundContent();

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();

    // Return focus to the triggering element if available
    if (this.triggeringElement && typeof this.triggeringElement.focus === 'function') {
      this.triggeringElement.focus();
      this.triggeringElement = null;
    }
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);

        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector,
          );
        }
      }
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this)),
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  elemsToHideSelector = '.hide-when-in-modal';
  hideBackgroundContent() {
    document
      .querySelectorAll(this.elemsToHideSelector)
      .forEach((el) => el.setAttribute('inert', true));
  }

  showBackgroundContent() {
    document
      .querySelectorAll(this.elemsToHideSelector)
      .forEach((el) => el.removeAttribute('inert'));
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
